<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link :to="{ name: 'Home' }">Accueil</router-link></li>
        <li
          class="breadcrumb-item active"
          aria-current="page">Leçons de formation</li>
      </ol>
    </nav>
    <b-row>
      <b-col>
        <b-card-group deck>
          <b-card
            header="Liste des leçons"
            align="center"
            class="scrollable-card">
            <b-card-text>
              <list-training/>
            </b-card-text>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <b-card-group deck>
          <b-card
            header="Liste des usages"
            align="center">
            <b-card-text>
              <list-training-associations
                type="usage"
                title="Liste des usages"
              />
            </b-card-text>
          </b-card>
          <b-card
            header="Liste des besoins"
            align="center">
            <b-card-text>
              <list-training-associations
                type="need"
                title="Liste des besoins"
              />
            </b-card-text>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <b-card-group deck>
          <b-card
            header="Statistiques de consultation"
            align="center"
            class="scrollable-card">
            <b-card-text>
              <list-training-stats/>
            </b-card-text>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ListTraining from '../components/lists/ListTraining.vue';
import FormTraining from '../components/forms/FormTraining.vue';
import ListTrainingAssociations from '../components/lists/ListTrainingAssociations.vue';
import ListTrainingStats from '../components/lists/ListTrainingStats.vue';

export default {
  components: {
    ListTrainingStats,
    ListTrainingAssociations,
    FormTraining,
    ListTraining,
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style>
.scrollable-card {
  overflow-x: scroll;
}
</style>
